import {Badge} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {OrderStatus} from '../types';
import {TIMESTAMP_PLACEHOLDER} from '../../../utils/TableTimestamps.tsx';

const COLORS: Record<OrderStatus, string> = {
    PENDING: 'yellow',
    PROCESSING: 'blue',
    COMPLETED: 'green',
    CANCELLED: 'gray',
};

// The status is text on the badge, so colour never carries it alone (§13). An order with no
// status renders the shared placeholder rather than an empty badge.
export const OrderStatusBadge = ({status}: { status?: OrderStatus | null }) => {
    if (!status) {
        return <>{TIMESTAMP_PLACEHOLDER}</>;
    }
    return <Badge color={COLORS[status] ?? 'gray'}>{I18n.get(status)}</Badge>;
};
